export default __webpack_public_path__ + "static/media/turkey.aa87957f.webp";